import React from 'react';
import { TextField } from 'components/forms';

export default React.createClass({
    propTypes: {
        errors: React.PropTypes.object,
        onFormChanged: React.PropTypes.func.isRequired,
    },

    getInitialState() {
        return {
            data: {},
            errors: this.props.errors || {},
        };
    },

    handleFieldChanged(name, value) {
        const form = this.state.data;
        form[name] = value;

        this.setState({ data: form }, () => {
            this.props.onFormChanged(form);
        });
    },

    render() {
        return (
            <div className="row">
                <div className="form-row">
                    <div className="col-xs-12">
                        <div className="clearfix">
                            <label className="pull-left">Card Number</label>
                            <div className="cards pull-right">
                                <img src="/cards/visa.png" />
                                <img src="/cards/mastercard.png" />
                                <img src="/cards/amex.png" />
                                <img src="/cards/discover.png" />
                            </div>
                        </div>
                        <TextField name="card_number"
                                   value={this.state.data.card_number}
                                   error={this.props.errors.card_number}
                                   onChange={this.handleFieldChanged.bind(this, 'card_number')}
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="col-xs-12">
                        <TextField name="name"
                                   label="Name on Card"
                                   value={this.state.data.name}
                                   error={this.props.errors.name}
                                   onChange={this.handleFieldChanged.bind(this, 'name')}
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="col-xs-4">
                        <TextField name="cvc"
                                   label="CVC"
                                   placeholder="ex. 311"
                                   value={this.state.data.cvc}
                                   error={this.props.errors.cvc}
                                   onChange={this.handleFieldChanged.bind(this, 'cvc')}
                        />
                    </div>

                    <div className="col-xs-4">
                        <TextField name="exp_month"
                                   label="Expiration"
                                   placeholder="MM"
                                   value={this.state.data.exp_month}
                                   error={this.props.errors.exp_month}
                                   onChange={this.handleFieldChanged.bind(this, 'exp_month')}
                        />
                    </div>

                    <div className="col-xs-4">
                        <label></label>
                        <TextField name="exp_year"
                                   placeholder="YYYY"
                                   value={this.state.data.exp_year}
                                   error={this.props.errors.exp_year}
                                   onChange={this.handleFieldChanged.bind(this, 'exp_year')}
                        />
                    </div>
                </div>
            </div>
        );
    },
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/invoice/newCardForm.jsx